var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c("create-filter", {
            attrs: {
              account: _vm.account
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v(" Current Filters ")]),
              _c(
                "gg-card-text",
                [
                  _c("filter-table", {
                    attrs: {
                      account: _vm.account
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }